<template>
  <div>
    Associating your store with <b>alme</b> profile....
    <b-modal title="Account connected" class="modal-success" v-model="successModal" ok-only ok-variant="success" @ok="goHome" no-close-on-esc no-close-on-backdrop hide-header-close>
      Your store was successfully associated with a current account. You are now able to control your store from portal.
    </b-modal>
    <b-modal title="Error happened" class="modal-danger" v-model="errorModal" ok-only ok-variant="danger" @ok="goHome" no-close-on-esc no-close-on-backdrop hide-header-close>
      {{errorMessage}}
    </b-modal>

  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: "AppConnect",
      data () {
        return {
          successModal: false,
          errorModal: false,
          errorMessage: ""
        }
    },
    methods:{
      goHome(){
        this.$router.push("/");
      }
    },
    mounted(){
      axios.post(new URL('shopify/associate', process.env.VUE_APP_API_URL), {
        code: this.$route.params.code,
        applicationName: this.$route.params.appname
      }).then(
        () => {
          this.$data.successModal = true;
        },
        (error) => {
          if(!!error.response){
            this.$data.errorMessage = error.response.data;
          }else{
            this.$data.errorMessage = "There was an error processing your request. Try again later or contact support."
          }
          this.$data.errorModal = true;

        });
    }
  }
</script>

<style scoped>

</style>
